import { Route, Routes } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';
import { JSX } from 'react';

import { LayoutPrimary } from './layout-primary';
import { LandingPage } from './landing-page';
import { useLocale } from '../../../context';

export const App = (): JSX.Element => {
  const intl = useIntl();
  const { locale } = useLocale();

  return (
    <>
      <Helmet htmlAttributes={{ lang: locale }}>
        <title>
          {intl.formatMessage({ id: 'app.title', defaultMessage: '' })}
        </title>
        <meta name="description" content={intl.formatMessage({ id: 'app.description' })} />
      </Helmet>
      <Routes>
        <Route element={<LayoutPrimary />}>
          <Route path="/" element={<LandingPage />} />
        </Route>
      </Routes>
    </>
  );
};
